import React, { useState } from 'react';
import './FAQPage.css';
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import faqimage from './assets/faqimage.png';
import faqPoster from './assets/faqPoster.png';

const FAQPage = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        if (activeIndex === index) {
            setActiveIndex(null); // Close if it's already open
        } else {
            setActiveIndex(index); // Open the clicked accordion item
        }
    };

    const faqData = [
        {
            question: "What do I have to do to buy a car?",
            answer: "Registration is required. After registration is completed, you can buy any car that you want."
        },
        {
            question: "Do you have any criteria to become a registered member of MI JAPAN?",
            answer: "Anyone who is an automobile dealer or an individual buyer can apply for membership. However, for an individual car buyer, we encourage you to check your country's regulations before purchase. We are not familiar with the laws of your country. We are not able to offer you any advice, or to introduce you to any car importer or customs clearing agent in your country."
        },
        {
            question: "How many used cars are normally available in your Inventory and in auction?",
            answer: "Usually, we have more than a thousand cars in our regular inventory. In addition, you can have access to about 150,000 cars a week available at different online auctions we cover. Usually, we have 2 to 3 RORO Ships and 4 to 5 Container Shipments in a month."
        },
        {
            question: "What payment methods can be accepted by MI JAPAN?",
            answer: "Because of the high frequency of credit card fraud, we don't accept payment by credit card. We only accept payment by telegraphic transfer to our designated bank account from your bank or via Pay Pal."
        },
        {
            question: "How long does it take me to receive my car?",
            answer: "We cannot tell you about the exact time for your car to be delivered to you as it completely depends on the shipping schedule. However, your car will be shipped on the earliest available vessel. Usually, it takes 4 to 8 weeks."
        },
        {
            question: "Is there any membership fee?",
            answer: "No. No fees or hidden charges are required. So don't hesitate and sign up now."
        },
        {
            question: "If I purchase a vehicle for $ 2,000, how much will I have to pay as extra charges?",
            answer: "If the price is in FOB, you will have to pay Freight charge, Clearance fee, import duty, Registration fee, Compliance fee, and any other fee which may occur according to the import regulations of your country. If the price is in C&F, you can omit Freight charge from the above charges."
        },
        {
            question: "Can I purchase LHD cars from MI JAPAN?",
            answer: "LHD cars are very rare in Japan. LHD cars are usually imported from countries like United States, Europe and Korea. However, you can search for an LHD car in a fair amount of Korean and American Inventory.(if any)"
        },
        {
            question: "Can I cancel my purchase order?",
            answer: "When you cancel an order, we may have to resell that car in an auction or in any other way. Therefore, if you cancel the order, you must pay the balance in addition to the costs that may incur."
        },
        {
            question: "Do you inspect the cars before shipping?",
            answer: "All the cars are thoroughly inspected to confirm that there is no difference between the actual specifications and those on the specification sheet."
        },
        {
            question: "When can I use an online auction service?",
            answer: "You can use it every day."
        },
        {
            question: "Is there any way to know an indicative bidding price for a vehicle I am interested in at an auction?",
            answer: "Yes, the data from recent auctions will be a good source of information. It indicates the prices of vehicles that have been sold over the last 3 months."
        },
        {
            question: "Do your staff inspect cars before bidding?",
            answer: "We have highly skilled professionals who carefully inspect every car. Before the professionals decide to bid for a car, they confirm that the actual specification and condition of the car matches the information provided by the auction house."
        },
    ];

    return (
        <div className="row">
            <div className="col-1 leftcol">
                {/* <HomeLeft /> */}
            </div>
            <div className="col-10 middlecol">
                <div className="faq-container">
                    <h1>Do You Have Questions?</h1>
                    <h4>We have answers (well, most of the times!)</h4>
                    <img src={faqPoster} alt="faqimage" className="logo-image" />
                    <h2>FAQ’s</h2>
                    <div className="accordion d-none">
                        {faqData.map((faq, index) => (
                            <div key={index} className="accordion-item">
                                <div
                                    className={`accordion-header ${activeIndex === index ? 'active' : ''}`}
                                    onClick={() => toggleAccordion(index)}
                                >
                                    <div className="accordion-number">{index + 1}</div> {/* This will display the number in a circle */}
                                    <h3>{faq.question}</h3>
                                </div>
                                {activeIndex === index && (
                                    <div className="accordion-content">
                                        <p>{faq.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="contact-info">
                        <h3>For further questions, feel free to contact us</h3>
                        {/* <p>Call or WhatsApp: +81 90-8100-0786</p>
                        <p>Fax: +81 0299-56-4954</p> */}
                        <p>Email:  info@saadmotors.com</p>
                    </div>
                </div>
            </div>
            <div className="col-1 rightcol">
                {/* <HomeRight /> */}
            </div>
        </div>
    );
};

export default FAQPage;
